"use client";

import React from "react";
import { ArrowRight, Sparkles, ShieldCheck, Activity, Microscope } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Queda e Alopecias",
  description: "Tratamentos especializados para eflúvios, calvície (alopécia androgenética) e alopécia areata.",
  benefits: ["Estímulo de crescimento", "Fortalecimento do folículo", "Controle da queda"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/hair_loss_treatment_microscope.png",
  icon: Activity,
  link: "/ProtocolsPage"
}, {
  title: "Distúrbios do Couro Cabeludo",
  description: "Controle de oleosidade excessiva, caspa, seborreia, sensibilidade e psoríase.",
  benefits: ["Equilíbrio da microbiota", "Alívio da coceira", "Redução da inflamação"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/scalp_care_therapy_analysis.png",
  icon: Microscope,
  link: "/ProtocolsPage"
}, {
  title: "Restauração Capilar",
  description: "Recuperação intensiva para fios danificados por química, corte químico e agressões externas.",
  benefits: ["Reconstrução da fibra", "Devolução de massa", "Brilho e maciez"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/hair_restoration_spa_treatment.png",
  icon: Sparkles,
  link: "/ProtocolsPage"
}, {
  title: "Prevenção e Bem-Estar",
  description: "Protocolos de manutenção para preservar a saúde capilar e prevenir futuras patologias.",
  benefits: ["Nutrição profunda", "Detox capilar", "Relaxamento e bem-estar"],
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1559261/img/preventive_hair_care_wellness.png",
  icon: ShieldCheck,
  link: "/ProtocolsPage"
}];
export default function SolucoesParaSuaSaudeCapilar() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="soluções-para-sua-saúde-capilar" className="relative w-full py-24 bg-background overflow-hidden" ref={ref}>
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-primary/5 blur-[120px]" />
        <div className="absolute top-[40%] -right-[10%] w-[40%] h-[60%] rounded-full bg-secondary/5 blur-[100px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-4xl md:text-5xl font-serif font-medium text-primary mb-6">
            Soluções Completas para sua Saúde Capilar
          </h2>
          <p className="text-lg text-muted-foreground font-sans leading-relaxed">
            Combinamos ciência tricológica e terapias avançadas para diagnosticar e tratar as necessidades específicas do seu cabelo e couro cabeludo.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, i) => <div key={i} data-index={i} className={`group relative h-[480px] rounded-2xl overflow-hidden transition-all duration-700 delay-[${i * 100}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              {}
              <div className="absolute inset-0 w-full h-full">
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110" style={{
              backgroundImage: `url(${service.image})`
            }} />
                {}
                <div className="absolute inset-0 bg-gradient-to-b from-background/10 via-background/60 to-background/95 group-hover:via-background/40 group-hover:to-background/90 transition-colors duration-500" />
              </div>

              {}
              <Card className="relative h-full bg-transparent border-none shadow-none flex flex-col justify-end p-6">
                <CardContent className="p-0 flex flex-col h-full justify-end">
                  
                  {}
                  <div className="mb-4 transform transition-transform duration-500 group-hover:-translate-y-2">
                    <div className="w-12 h-12 rounded-full bg-white/80 backdrop-blur-sm flex items-center justify-center mb-4 text-primary shadow-sm">
                      <service.icon className="w-6 h-6" />
                    </div>
                    <h3 className="text-2xl font-serif font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                      {service.title}
                    </h3>
                    <p className="text-sm text-muted-foreground font-sans line-clamp-3 mb-4 group-hover:text-foreground/80 transition-colors">
                      {service.description}
                    </p>
                    
                    {}
                    <ul className="space-y-1 mb-4">
                      {service.benefits.map((benefit, idx) => <li key={idx} className="flex items-center text-xs font-medium text-primary/80">
                          <span className="w-1.5 h-1.5 rounded-full bg-primary mr-2" />
                          {benefit}
                        </li>)}
                    </ul>
                  </div>

                  {}
                  <div className="overflow-hidden h-0 group-hover:h-12 transition-all duration-500 ease-out opacity-0 group-hover:opacity-100">
                    <Button asChild className="w-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-md group-hover:translate-y-0 translate-y-full transition-transform duration-500">
                      <Link to={service.link}>
                        Saiba Mais <ArrowRight className="ml-2 w-4 h-4" />
                      </Link>
                    </Button>
                  </div>
                  
                  {}
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}